import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=6e0d6e5c"
import script from "./Rule.ts?vue&type=script&lang=ts&external"
export * from "./Rule.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports